import PropTypes from "prop-types";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import { selectAuthUser } from "store/reducer";
import {
  getAvatarUrl,
  getDisplayName,
  getInitials,
} from "lib/authUserDisplay";

export default function SettingsAccountSummary({ className = "" }) {
  const user = useSelector(selectAuthUser);

  const displayName = useMemo(() => getDisplayName(user), [user]);
  const email = useMemo(() => String(user?.email ?? "").trim(), [user]);
  const avatarUrl = useMemo(() => getAvatarUrl(user), [user]);
  const initials = useMemo(() => getInitials(user), [user]);

  return (
    <div
      className={[
        "flex items-center gap-5 rounded-xl border border-slate-200 bg-white p-6 shadow-card",
        className,
      ].join(" ")}
    >
      {avatarUrl ? (
        <img
          src={avatarUrl}
          alt=""
          key={avatarUrl}
          className="h-20 w-20 shrink-0 rounded-full border border-slate-200 object-cover"
        />
      ) : (
        <div
          className="flex h-20 w-20 shrink-0 items-center justify-center rounded-full border border-slate-200 bg-brand-900 text-xl font-bold text-white"
          aria-hidden
        >
          {initials}
        </div>
      )}
      <div className="min-w-0">
        <p className="truncate text-sm font-semibold text-text-900">{displayName}</p>
        {email ? (
          <p className="mt-1 truncate text-sm text-text-500">{email}</p>
        ) : (
          <p className="mt-1 text-sm text-text-500">No email on file</p>
        )}
      </div>
    </div>
  );
}

SettingsAccountSummary.propTypes = {
  className: PropTypes.string,
};
